import * as React from 'react';
import { InlineText2, Wait16 } from '@cian/ui-kit';

import * as styles from './warning.css';

interface IActualProps {
  label: string;
  tooltip: React.ReactNode;
}
export const Warning = ({ label, tooltip }: IActualProps) => {
  return (
    <div className={styles['warning']}>
      <div className={styles['label']}>
        <div className={styles['warn']}>
          <Wait16 color="error_100" />
        </div>
        <InlineText2 color="error_100">{label}</InlineText2>
      </div>
      {tooltip}
    </div>
  );
};

Warning.displayName = 'Warning';
